import axios from 'axios'
import { CONFIGS } from '../configs'

export default {
  list(page, search, status) {
    if(page === undefined) page = 1
    if(search === undefined || search==='') search = ''; else search = '&search='+search
    if(status === undefined || status==='') status = ''; else status = '&status='+status
    return axios.get(CONFIGS.API_SERVER + '/signature/?ordering=-id&page='+page+search+status)
  },
  get(id) {
    return axios.get(CONFIGS.API_SERVER + '/signature/' + id)
  },
  getClientsByPublication(publication) {
    return axios.get(CONFIGS.API_SERVER + '/signature/?page=1&limit=1000&status__in=1,2,3,5&publication__id='+publication+'&ordering=profile__name,profile__company_name')
  },
  getClientsByPublicationPDF(data) {
    if(status === undefined) var status = 1
    return axios.post(CONFIGS.API_SERVER + '/api/get_users_from_publication/', data)
  },
  create(data) {
    return axios.post(CONFIGS.API_SERVER + '/signature/', data)
  },
  update(data, id) {
    return axios.put(CONFIGS.API_SERVER + '/signature/' + id + '/', data)
  },
  getCertificate(data) {
    if(data === undefined) data = {}
    return axios.post(CONFIGS.API_SERVER + '/api/get_certificate/', data)
  }
}
